import {Observable, Subscription} from 'rxjs';

import ITimelineStore from '../Interfaces/ITimelineStore';

const subscribeToTimelineInspect = (
    timelineInspect$: Observable<number>,
    timelineStore: ITimelineStore
): Subscription =>
    timelineInspect$
        .subscribe((multiplier: number) => timelineStore.actions.inspect(multiplier));

export default subscribeToTimelineInspect;